<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.zsmj1">&nbsp; &nbsp;
        <img :src="images.zsmj2" style="line-height:1.5;">
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:18px;font-family:宋体;">注塑模具</span>
        </b>
        <b>
          <span style="font-size:16.0pt;font-family:Arial;"></span>
        </b>
      </p>
      <p>
        <span style="font-size:18px;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <span
          style="font-size:12.0pt;font-family:宋体;color:black;"
        >注塑产品涉及电子、机械、化妆品、食品等行业。我公司提供设计，加工，保修等一条龙服务。</span>
      </p>
      <p>
        <br>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
        <img :src="images.zsmj3" style="line-height:1.5;">
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        zsmj1: require("../../../assets/img/common/zsmj1.jpg"),
        zsmj2: require("../../../assets/img/common/zsmj2.jpg"),
        zsmj3: require("../../../assets/img/common/zsmj3.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/device/zsmj.vue